import React, { Component } from 'react';
import { TextField } from '@material-ui/core';
import { validatePostalCode, WrongPostalCodeFormatText } from '../Auth/Common';

type Props = {
    value: string,
    onChange: (value: string, isValid: boolean) => void
    onBlur?: () => void,
    variant?: any,
    label?: string
}

type State = {
    postalCodeFormatError: boolean,
    //postalCode: string
}

class PostalCodeInput extends Component<Props, State>  {
    constructor(props: Props) {
        super(props)

        this.state = {
            postalCodeFormatError: false,
            //postalCode: this.props.value
        }
    }

    render() {
        return (
            <TextField
                onChange={(e) => {
                    let isValid = validatePostalCode(e.target.value)
                    this.setState({ postalCodeFormatError: !isValid })
                    this.props.onChange(e.target.value, isValid)
                }}
                value={this.props.value}
                onBlur={this.props.onBlur}
                label={this.props.label || "Postal Code*"}
                margin="normal"
                variant={this.props.variant || "outlined"}
                style={{ width: '100%' }}
                helperText={this.state.postalCodeFormatError ? WrongPostalCodeFormatText : ''}
                error={this.state.postalCodeFormatError}
            ></TextField>);
    }
}

export default PostalCodeInput;